var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "rounded-0" },
    [
      _c("h4", { staticClass: "text-center" }, [
        _vm._v(_vm._s(_vm.$t("message.signUp.title")))
      ]),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          staticClass: "mt-4 p-4 mx-auto",
          attrs: {
            variant: _vm.notification.variant,
            dismissible: "",
            show: _vm.notification.isVisible
          },
          on: {
            dismissed: function($event) {
              _vm.notification.isVisible = false
            }
          }
        },
        [
          _c(
            "i18n",
            { attrs: { path: "error.signUp.submit", tag: "div" } },
            [
              _c(
                "b-link",
                {
                  attrs: {
                    href: "mailto:support@meine-vertraege.net",
                    place: "supportLink"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("message.support.email")) + "\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form",
        {
          staticClass: "mt-3 p-3",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                state: _vm.$v.regData.salutation.$error ? false : null,
                "invalid-feedback": _vm.$t("error.signUp.salutation")
              }
            },
            [
              _c("label", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.signUp.label.salutation")) +
                    "\n        "
                ),
                _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              ]),
              _vm._v(" "),
              _c("b-form-radio-group", {
                attrs: {
                  options: _vm.salutations,
                  state: _vm.$v.regData.salutation.$error ? false : null
                },
                on: {
                  change: function($event) {
                    _vm.$v.regData.salutation.$touch()
                  }
                },
                model: {
                  value: _vm.regData.salutation,
                  callback: function($$v) {
                    _vm.$set(_vm.regData, "salutation", $$v)
                  },
                  expression: "regData.salutation"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.$v.regData.firstName.$error ? false : null,
                        "invalid-feedback": _vm.$t("error.signUp.firstName")
                      }
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.signUp.label.firstName")) +
                            "\n            "
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        attrs: {
                          state: _vm.$v.regData.firstName.$error ? false : null
                        },
                        on: {
                          change: function($event) {
                            _vm.$v.regData.firstName.$touch()
                          }
                        },
                        model: {
                          value: _vm.regData.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.regData, "firstName", $$v)
                          },
                          expression: "regData.firstName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.$v.regData.lastName.$error ? false : null,
                        "invalid-feedback": _vm.$t("error.signUp.lastName")
                      }
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.signUp.label.lastName")) +
                            "\n            "
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        attrs: {
                          state: _vm.$v.regData.lastName.$error ? false : null
                        },
                        on: {
                          change: function($event) {
                            _vm.$v.regData.lastName.$touch()
                          }
                        },
                        model: {
                          value: _vm.regData.lastName,
                          callback: function($$v) {
                            _vm.$set(_vm.regData, "lastName", $$v)
                          },
                          expression: "regData.lastName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.invitation
            ? _c(
                "b-form-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            id: "signup-relation",
                            "label-for": "signup-relation",
                            state: _vm.$v.regData.relation.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t("error.signUp.relation")
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.relationText) +
                                  "\n            "
                              ),
                              _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("b-form-select", {
                            staticClass: "rounded-0",
                            attrs: { options: _vm.relationTypes },
                            model: {
                              value: _vm.regData.relation,
                              callback: function($$v) {
                                _vm.$set(_vm.regData, "relation", $$v)
                              },
                              expression: "regData.relation"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.$v.regData.email.$error ? false : null,
                        "invalid-feedback": _vm.$t("error.signUp.email")
                      }
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.signUp.label.email")) +
                            "\n            "
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        attrs: {
                          id: "email",
                          state: _vm.$v.regData.email.$error ? false : null
                        },
                        on: {
                          change: function($event) {
                            _vm.$v.regData.email.$touch()
                          }
                        },
                        model: {
                          value: _vm.regData.email,
                          callback: function($$v) {
                            _vm.$set(_vm.regData, "email", $$v)
                          },
                          expression: "regData.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.$v.regData.password.$error ? false : true,
                        "invalid-feedback": _vm.$t("error.signUp.password")
                      }
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.signUp.label.password")) +
                            "\n            "
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        attrs: {
                          type: "password",
                          state: _vm.$v.regData.password.$error ? false : null
                        },
                        on: {
                          textinput: function($event) {
                            _vm.$v.regData.password.$touch()
                          }
                        },
                        model: {
                          value: _vm.regData.password,
                          callback: function($$v) {
                            _vm.$set(_vm.regData, "password", $$v)
                          },
                          expression: "regData.password"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "feedback-color",
                          attrs: { slot: "valid-feedback" },
                          slot: "valid-feedback"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("error.signUp.password")) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.$v.regData.passwordConfirm.$error
                          ? false
                          : null,
                        "invalid-feedback": _vm.$t(
                          "error.signUp.passwordConfirm"
                        )
                      }
                    },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("message.signUp.label.passwordConfirm")
                            ) +
                            "\n            "
                        ),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        staticClass: "rounded-0",
                        attrs: {
                          type: "password",
                          state: _vm.$v.regData.passwordConfirm.$error
                            ? false
                            : null
                        },
                        on: {
                          change: function($event) {
                            _vm.$v.regData.passwordConfirm.$touch()
                          }
                        },
                        model: {
                          value: _vm.regData.passwordConfirm,
                          callback: function($$v) {
                            _vm.$set(_vm.regData, "passwordConfirm", $$v)
                          },
                          expression: "regData.passwordConfirm"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.invitation
            ? _c(
                "b-form-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.regData.dateOfBirth.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.signUp.dateOfBirth"
                            )
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("message.signUp.label.dateOfBirth")
                                ) +
                                "\n            "
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                staticClass: "rounded-0",
                                attrs: {
                                  state: _vm.$v.regData.dateOfBirth.$error
                                    ? false
                                    : null
                                },
                                on: {
                                  textinput: function($event) {
                                    _vm.$v.regData.dateOfBirth.$touch()
                                  }
                                },
                                model: {
                                  value: _vm.regData.dateOfBirth,
                                  callback: function($$v) {
                                    _vm.$set(_vm.regData, "dateOfBirth", $$v)
                                  },
                                  expression: "regData.dateOfBirth"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-input-group-text",
                                {
                                  staticClass: "rounded-0",
                                  attrs: { slot: "append" },
                                  slot: "append"
                                },
                                [_c("span", { staticClass: "ti-calendar" })]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.invitation
            ? _c(
                "b-form-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            state: _vm.$v.regData.contractNumber.$error
                              ? false
                              : null,
                            "invalid-feedback": _vm.$t(
                              "error.signUp.contractNumber"
                            )
                          }
                        },
                        [
                          _c("label", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("message.signUp.label.contractNumber")
                                ) +
                                "\n            "
                            ),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            staticClass: "rounded-0",
                            attrs: {
                              state: _vm.$v.regData.contractNumber.$error
                                ? false
                                : null
                            },
                            on: {
                              change: function($event) {
                                _vm.$v.regData.contractNumber.$touch()
                              }
                            },
                            model: {
                              value: _vm.regData.contractNumber,
                              callback: function($$v) {
                                _vm.$set(_vm.regData, "contractNumber", $$v)
                              },
                              expression: "regData.contractNumber"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        state: _vm.$v.regData.acceptTerms.$error ? false : null,
                        "invalid-feedback": _vm.$t("error.signUp.acceptTerms")
                      }
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            state: _vm.$v.regData.acceptTerms.$error
                              ? false
                              : null
                          },
                          on: {
                            change: function($event) {
                              _vm.$v.regData.acceptTerms.$touch()
                            }
                          },
                          model: {
                            value: _vm.regData.acceptTerms,
                            callback: function($$v) {
                              _vm.$set(_vm.regData, "acceptTerms", $$v)
                            },
                            expression: "regData.acceptTerms"
                          }
                        },
                        [
                          _c(
                            "i18n",
                            {
                              attrs: {
                                path: "message.signUp.termsAndPolicies",
                                tag: "p"
                              }
                            },
                            [
                              _c(
                                "router-link",
                                { attrs: { to: "/terms", place: "terms" } },
                                [_vm._v(_vm._s(_vm.$t("message.signUp.terms")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: "/policies",
                                    place: "privacyPolicies"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("message.signUp.privacyPolicies")
                                    ) + "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-btn",
                    {
                      staticClass: "w-100 p-3 rounded-0",
                      attrs: {
                        variant: "primary",
                        type: "submit",
                        disabled: _vm.$v.$invalid
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("message.signUp.btn.submit")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-row",
            { staticClass: "mt-4" },
            [
              _c(
                "b-col",
                { staticClass: "text-center" },
                [
                  _c(
                    "i18n",
                    { attrs: { path: "message.signUp.signIn", tag: "p" } },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: "/signin", place: "signInLink" } },
                        [_vm._v(_vm._s(_vm.$t("message.signUp.signInHere")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f79ce3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f79ce3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/SignUp.vue
// module id = IHl5
// module chunks = 1